import {getField, updateField} from 'vuex-map-fields';
import BaseTableModule from '@/commonFunction/baseTableModule'

let mpnresearchDetail = new BaseTableModule('/ws/mpnresearch_detail/');

const state = {
    ...mpnresearchDetail.state,
    columns: [],
    briefView: true,
    options: {
        page: 1,
        itemsPerPage: 1000,
        sortBy: ['order_number'],
        sortDesc: [false],
        multiSort: false,
        mustSort: true,
        descending: true,

    },
};
const getters = {
    ...mpnresearchDetail.getters,
    getColumns(state, getters, rootState, rootGetters) {
        let columns = [
            {text: '', value: 'drag', sortable: false, divider: true, width: 30},
            // {text: 'id', value: 'id', sortable: false, divider: true, width: 30},
            {text: '№', value: 'order_number', sortable: false, divider: true, width: 30},
            {text: '', value: 'task_id', sortable: false, divider: true, width: 70},
            // {text: 'Task Status', value: 'task_status', sortable: false, divider: true, width: 70},
            {text: 'QTY', value: 'qty', sortable: false, divider: true, width: 100},
            {
                text: 'Original text',
                value: 'original_text',
                sortable: false,
                filterable: true,
                divider: true,
                width: 200,
            },
            {text: 'MPN', value: 'mpn', sortable: false, divider: false, width: 300,},
            {text: '', value: 'search_link', sortable: false, divider: true, width: 50,},
            {text: 'Partial match', value: 'partial_match', sortable: false, divider: true, width: 70},
            {text: 'Exclude from view', value: 'bc_exclude_from_view', sortable: false, divider: true, width: 140},
        ]
        const batchSizeList = rootGetters['MPNResearchBatch/getBatchSizeList']
        if (batchSizeList != null)
            for (const batchSize of batchSizeList)
                columns.push({
                    text: batchSize.batch_size.toString(),
                    value: batchSize.batch_size.toString(),
                    sortable: false,
                    divider: true,
                    width: 150
                })
        columns.push({text: 'Comment', value: 'comment', sortable: false, divider: true, width: 150})
        columns.push({text: 'Edited by', value: 'edited_by__username', sortable: true, divider: true, brief: true,})
        columns.push({text: 'Edited on', value: 'edited_on', sortable: true, divider: true, brief: true,})
        return columns
    },
};
const actions = {
    ...mpnresearchDetail.actions,
    async actionAddClipboard(ctx, bomMpnResearchId) {
        ctx.commit('updateAddFromClipboardLoading', true)
        if (navigator.clipboard == null) {
            this._vm.$toast.error("This requires a secure origin — either HTTPS or localhost (or disabled by running Chrome with a flag).\n\n" +
                "In chrome://flags, enable 'Insecure origins treated as secure' and give it the origin you want.", {timeout: 15000})
            ctx.commit('updateAddFromClipboardLoading', false)
            return
        }

        const readFullText = await navigator.clipboard.readText()
        const clipboardArray = getCellsFromClipboard(readFullText)

        let order_number = ctx.state.itemList.length
        for (const lineArray of clipboardArray) {
            let qty = null
            try {
                qty = parseInt(lineArray[0])
            } catch (error) {
                qty = null
                this._vm.$toast.error("Error convert " + lineArray[0] + "to integer", {timeout: 5000})
            }
            let fields_dict = {
                qty: qty,
                original_text: lineArray[1],
                mpn: lineArray[1],
                mpn_research: bomMpnResearchId,
                id: null,
                order_number: order_number,
            }
            order_number++
            ctx.dispatch('fetchSaveItemField', {
                itemId: null,
                fields_dict: fields_dict,
            })
        }
        ctx.commit('updateAddFromClipboardLoading', false)
    },
};
const mutations = {
    ...mpnresearchDetail.mutations,
    updateAddFromClipboardLoading(state, addFromClipboardLoading) {
        state.addFromClipboardLoading = addFromClipboardLoading
    },
};

export default {
    modules: {
        MPNResearchDetail: {
            namespaced: true,
            state,
            getters,
            actions,
            mutations
        }
    }
}

function getCellsFromClipboard(readFullText) {
    let formatCellText = readFullText.replace(/(".*)\n(.*")/g, (match, first, last) => `${first}...${last}`);
    // console.log('formatCellText', formatCellText)
    let clipboardArray = []
    for (const row of formatCellText.split('\n')) {
        const cells = row.split('\t')
        let line = []
        for (let cell of cells) {
            line.push(cell.replace('...', '\n').replace(/"/g, ''))
        }
        if (line.length === 2)
            clipboardArray.push(line)
    }
    return clipboardArray
}